module.exports = __webpack_public_path__ + "static/sala_de_juntas.min-475eebf2e91fd8d33d0acb3445690825.png";